export const SHOW_START = 'SHOW_START';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_FAILURE = 'SHOW_FAILURE';

export const UPDATE_START = 'UPDATE_START';
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS';
export const UPDATE_FAILURE = 'UPDATE_FAILURE';

export const BEFORE_LOGIN_START = 'BEFORE_LOGIN_START';
export const BEFORE_LOGIN_SUCCESS = 'BEFORE_LOGIN_SUCCESS';
export const BEFORE_LOGIN_FAILURE = 'BEFORE_LOGIN_FAILURE';

export const CONNECTION_START = 'CONNECTION_START';
export const CONNECTION_SUCCESS = 'CONNECTION_SUCCESS';
export const CONNECTION_FAILURE = 'CONNECTION_FAILURE';

export const IMPORT_START = 'IMPORT_START';
export const IMPORT_SUCCESS = 'IMPORT_SUCCESS';
export const IMPORT_FAILURE = 'IMPORT_FAILURE';

export const CONNECTION_IDP_START = 'CONNECTION_IDP_START';
export const CONNECTION_IDP_SUCCESS = 'CONNECTION_IDP_SUCCESS';
export const CONNECTION_IDP_FAILURE = 'CONNECTION_IDP_FAILURE';

export const IMPORT_IDP_START = 'IMPORT_IDP_START';
export const IMPORT_IDP_SUCCESS = 'IMPORT_IDP_SUCCESS';
export const IMPORT_IDP_FAILURE = 'IMPORT_IDP_FAILURE';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
